"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Fuse = require("fuse.js");
function create(items) {
    return new Fuse(items, {
        id: "id",
        keys: [
            "id",
            "contents",
            "manifest.displayName",
            "manifest.description",
            "manifest.name",
            "manifest.version",
            "manifest.tags",
            "manifest.flag"
        ]
    });
}
exports.create = create;
//# sourceMappingURL=search.js.map